import React from "react";
import classes from "./CreativeContainer.module.css";
import creativeVideo from "../../../assets/video/craetive.webm";
import AthourVideo from "../../../assets/video/AthourVideo.webm";
import SecondaryButton from "../../../components/Buttons/SecondaryButton";
import { Link } from "react-router-dom";

function CreativeContainer() {
  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <div className={classes.right}>
          <div className={classes.videoContainer}>
            <div className={classes.videoWrapper}>
              <video
                className={classes.bannerVideo}
                preload="auto"
                playsInline
                datatype="video"
                width="auto"
                height="auto"
                autoPlay
                loop
                muted
                style={{ width: "100%", height: "100%" }}
              >
                <source type="video/webm" src={creativeVideo} />
              </video>
            </div>
          </div>
        </div>
        <div className={classes.left}>
          <div className={classes.authorVideoContainer}>
            <video
              className={classes.authorVideo}
              preload="auto"
              playsInline
              datatype="video"
              width="auto"
              height="auto"
              autoPlay
              loop
              muted
              style={{ width: "100%", height: "100%" }}
            >
              <source type="video/webm" src={AthourVideo} />
            </video>
          </div>
          <p className={classes.content}>
            Writing a book is now super easy with{" "}
            <b>Bookalooza’s online book-writing platform!</b> Thousands of young
            writers like you have already become published authors, and now it’s
            your turn to write and publish a book effortlessly. Just type your
            story, format it with simple tools, add pictures to make it
            exciting, and publish it with a click. <b>The best part?</b> You
            start earning royalties on every book sale—just like a real author!
            Ready to begin your journey to becoming a{" "}
            <b>successful young writer?</b>
          </p>
          <Link to="/newbook">
            <SecondaryButton className={classes.createNowButton}>
              Write Your Book Now!
            </SecondaryButton>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CreativeContainer;
